<template>
  <!-- 这个是一条小线 -->
  <div class="id_8">

    <div class="border"></div>
  
  </div>
</template>

<script>

export default {
  props: {
    data: Object
  },
  name: 'id_8'
}
</script>

<style lang="scss" scoped>
.id_8{
  padding-top: 24px;
  border-bottom: 1px solid #EBEEF5;
}
</style>



// WEBPACK FOOTER //
// src/components/module/course/public/id_8.vue